import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

/**
 * Root redirect for "/"  — per the user's instruction the splash screen has
 * been retired. Authenticated users land on /dashboard, everyone else on
 * /login (which now also serves as the marketing entry point with a
 * role-aware sign-in flow).
 */
export default function RootRedirect() {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div
        data-testid="root-redirect-loading"
        className="min-h-screen flex items-center justify-center bg-[#0A0A0A] text-white/40 text-xs uppercase tracking-[0.3em]"
      >
        Loading…
      </div>
    );
  }
  return <Navigate to={user ? '/dashboard' : '/login'} replace />;
}
